import { render, staticRenderFns } from "./ResourceCategoryForm.vue?vue&type=template&id=54f4e77c&"
import script from "./ResourceCategoryForm.vue?vue&type=script&lang=js&"
export * from "./ResourceCategoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports